import { Ajax } from "../utils/base";
import IP from "../config/config";
import QS from "qs"
// export function getAuthorInfo (params) {
//     const url = IP.apis() + '/common/sclass/get-author-info';
//     return Ajax(url, params, "GET")
// }
export function getAuthorInfo (params) {
    const url = IP.mApis() + '/news/expert/league/user-info';
    return Ajax(url, params, "GET")
}

export function getRecommendNew (params) {
    const url = IP.apis() + '/common/home/recommend-new';
    return Ajax(url, params, "GET")
}
export function getUserFollow (params) {
    const url = IP.passportApis() + '/user/follow';
    return Ajax(url, QS.stringify(params), "POST")
}
export function getUserUnFollow (params) {
    const url = IP.passportApis() + '/user/unfollow';
    return Ajax(url, QS.stringify(params), "POST")
}
export function getOrderFirstInfo (params) {
    const url = IP.mApis() + '/news/article/order/first-info';
    return Ajax(url, params, "GET")
}
